$(document).ready(function(){
    if($(window).width() >= 720) {
        $('.view-more-btn').hide();
        $('.view-all-actives-btn').hide();
    }
    if($(window).width() < 720 && $('.featured-collections-slider--item').length > 4) {
        $('.view-all-actives-btn').hide();
        $('.view-more-btn').click(function(){
            $('.featured-collections-slider--item').each(function(){
                if(!$(this).hasClass('promo-block-mosaic')) {
                    $(this).fadeIn(1000);
                }
            });
            $(this).hide();
            $('.view-all-actives-btn').show();
        });
    }
    if($(window).width() < 720 && $('.featured-collections-slider--item').length <= 4) {
        $('.view-more-btn').hide();
    }
});